export default __webpack_public_path__ + "static/how-img-56b284a31fa24df66b22a400d74bf444.png";